import React, { useState, useEffect } from 'react';
import { Bag, User } from 'iconoir-react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import '../components/ButtonStyles.css';

function BalcaoInfoModal({ show, onHide, onSave, mesaPreenchida }) {
  const [nomeCliente, setNomeCliente] = useState('');
  const [mesaCliente, setMesaCliente] = useState(mesaPreenchida || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (show) {
      setNomeCliente('');
      setMesaCliente(mesaPreenchida || '');
      setError('');
    }
  }, [show, mesaPreenchida]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!nomeCliente.trim()) {
      setError('Nome do cliente é obrigatório');
      return;
    }
    
    if (!mesaPreenchida && !mesaCliente.trim()) {
      setError('Mesa é obrigatória');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await onSave({
        nome_cliente: nomeCliente.trim(),
        mesa_cliente: mesaCliente.trim()
      });
    } catch (error) {
      setError('Erro ao salvar informações. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header style={{ borderBottom: '1px solid #e5e7eb', padding: '20px' }}>
        <Modal.Title style={{ fontSize: '1.1rem', fontWeight: 700, color: '#1a1a1a' }}>
          <Bag className="me-2" style={{ color: '#006affff' }} />
          Informações do Balcão
        </Modal.Title>
      </Modal.Header>
      
      <Form onSubmit={handleSubmit}>
        <Modal.Body style={{ padding: '24px', paddingBottom: '90px', backgroundColor: '#f9fafb' }}>
          <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '20px' }}>
            Para continuar com seu pedido no balcão, precisamos de algumas informações:
          </p>
          
          {error && (
            <Alert variant="danger" className="py-2 mb-3">
              <small>{error}</small>
            </Alert>
          )}
          
          <div className="d-flex align-items-center p-3 mb-3" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px' }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '8px', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e5e7eb', color: '#6b7280' }}>
              <User />
            </div>
            <div className="flex-grow-1" style={{ marginLeft: '12px' }}>
              <div className="small text-muted mb-1" style={{ fontSize: '0.75rem', color: '#6b7280' }}>Nome do Cliente *</div>
              <Form.Control
                type="text"
                placeholder="Digite como quer ser identificado/a"
                value={nomeCliente}
                onChange={(e) => setNomeCliente(e.target.value)}
                disabled={loading}
                autoFocus
                style={{ border: 'none', padding: '4px 0', fontSize: '0.9rem', backgroundColor: 'transparent' }}
              />
            </div>
          </div>
          
          <div className="d-flex align-items-center p-3" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px' }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '8px', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e5e7eb', color: '#6b7280' }}>
              <Bag />
            </div>
            <div className="flex-grow-1" style={{ marginLeft: '12px' }}>
              <div className="small text-muted mb-1" style={{ fontSize: '0.75rem', color: '#6b7280' }}>Mesa</div>
              {mesaPreenchida ? (
                <div style={{ padding: '4px 0', fontSize: '0.9rem', fontWeight: 600 }}>{mesaPreenchida}</div>
              ) : (
                <Form.Control
                  type="text"
                  placeholder="Digite apenas o número ou descreva o lugar"
                  value={mesaCliente}
                  onChange={(e) => setMesaCliente(e.target.value)}
                  disabled={loading}
                  style={{ border: 'none', padding: '4px 0', fontSize: '0.9rem', backgroundColor: 'transparent' }}
                />
              )}
            </div>
          </div>
        </Modal.Body>
        
        <Modal.Footer style={{ position: 'fixed', bottom: 0, left: 0, right: 0, borderTop: '1px solid #e5e7eb', padding: '20px', backgroundColor: '#fff', zIndex: 1050 }}>
          <Button 
            variant="primary" 
            type="submit"
            disabled={loading || !nomeCliente.trim() || (!mesaPreenchida && !mesaCliente.trim())}
            className="w-100 btn-primary-glow"
            style={{
              padding: '12px',
              borderRadius: '12px',
              backgroundColor: loading ? '#0039ff' : '#0039ff',
              border: 'none',
              fontSize: '0.9rem',
              fontWeight: '600',
              boxShadow: '0 4px 12px rgba(0,106,255,0.25)',
              opacity: (!nomeCliente.trim() || (!mesaPreenchida && !mesaCliente.trim())) ? 0.5 : 1
            }}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                Salvando...
              </>
            ) : (
              'Continuar com o pedido'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default BalcaoInfoModal;
